import { isBrowser } from './utils';

export function getValuesFromSessionStorage<TValues>(key: string): TValues | null {
  if (!isBrowser()) {
    return null;
  }

  try {
    const value = window.sessionStorage.getItem(key);
    if (value) {
      return JSON.parse(value);
    }
  } catch (err) {
    // Swallow
  }

  return null;
}
